import { render, staticRenderFns } from "./Chart.vue?vue&type=template&id=2ac7d80e&"
import script from "./Chart.vue?vue&type=script&lang=ts&"
export * from "./Chart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ac7d80e')) {
      api.createRecord('2ac7d80e', component.options)
    } else {
      api.reload('2ac7d80e', component.options)
    }
    module.hot.accept("./Chart.vue?vue&type=template&id=2ac7d80e&", function () {
      api.rerender('2ac7d80e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_AgingBalance/Chart.vue"
export default component.exports